// import ReactEcharts from 'echarts-for-react';
import { lazy, Suspense, useEffect, useState } from 'react';
import { Loader } from '../UI/loader';
import { ThemeColorPicker } from '../AgGridTable/custom/ThemeColorPicker';
import { DEFAULT_CHART_COLORS, EchartOption } from '../../enums';
import {
  useChartColors,
  useHasBasicConfig,
  useShowChartLabel,
  useShowGlobalConfig
} from '../../lib/store/v3/layout';
import { useMutation } from 'react-query';
import { useAuth } from '../../../../scripts/fb';
import { getWorkspace, setLocalStorage } from '../../utils';
import axios from 'axios';
import { baseurl } from '../../constant';
import { useCollectionMutations } from '../../customHooks/useCollectionMutations';
import { useLocation } from 'react-router';
import { useChartCalculationReports } from '../../lib/store/reports.store';

const ReactEcharts = lazy(() => import('echarts-for-react'));

export const Echart = ({
  optionData,
  heigth,
  width,
  className
}: {
  optionData: any;
  heigth?: number;
  width?: any;
  className?: string;
}) => {
  const [sideBottom, setSideBottom] = useState<boolean>(false);
  const themeColors = useChartColors((state: any) => state.colors);
  const showLabels = useShowChartLabel((state: any) => state.showLabels);
  const chartCalculationSelected = useChartCalculationReports(
    (state: any) => state.chartCalculationSelected
  );

  const chartTheme = {
    color: themeColors.length ? themeColors : undefined
  };

  useEffect(() => {
    function handleResize() {
      if (window.innerHeight < 690) {
        setSideBottom(true);
      } else {
        setSideBottom(false);
      }
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Removed excessive logging to prevent console spam in Control Tower
  // console.log('********Distributions Echart component data 4******** ', optionData);

  const chartData = optionData
    ? {
        ...optionData,
        series: optionData.series?.map((series: any, idx: number) => {
          const isPie = series.type === 'pie';
          const valueIndex = idx + 1;
          return {
            ...series,
            label: {
              ...(series.label || {}),
              show: showLabels,
              fontSize: 10,
              fontFamily: 'Montserrat',
              formatter: (params: any) => {
                const value = Array.isArray(params.value) ? params.value[valueIndex] : params.value;
                const formattedValue =
                  typeof value === 'number' ? value.toLocaleString('en-US') : value;

                if (chartCalculationSelected === EchartOption.PERCENTAGES) {
                  return `${isPie ? params.name + ': ' : ''}${formattedValue}\n%`;
                }
                if (isPie) {
                  return `${params.name}: ${formattedValue}`;
                }
                return formattedValue;
              }
            }
          };
        })
      }
    : optionData;

  return (
    <div style={{ flexGrow: '1', width: '100%', display: 'flex' }}>
      {' '}
      {chartData ? (
        <Suspense
          fallback={
            <div>
              <Loader showText={false} />
            </div>
          }>
          <div
            className={className || ''}
            style={
              className
                ? { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }
                : { width: '100%' }
            }>
            <ReactEcharts
              theme={chartTheme}
              option={chartData}
              lazyUpdate={true}
              notMerge={true}
              opts={{ renderer: 'canvas' }}
              style={
                className
                  ? {
                      margin: 0,
                      height: '100%',
                      minHeight: 0,
                      width: width && width > 0 ? width : '100%'
                    }
                  : {
                      margin: 0,
                      height:
                        window.outerWidth <= 820 || window.innerWidth <= 820
                          ? 360
                          : heigth && heigth > 0
                          ? heigth
                          : sideBottom || window.innerHeight < 690
                          ? 350
                          : 500,
                      width: width && width > 0 ? width : '100%'
                    }
              }
            />
          </div>
        </Suspense>
      ) : (
        <></>
      )}
    </div>
  );
};
